import {
  newGetFieldPlaceholder,
  newGetSelectFieldOptions,
  newIsFieldRequired, Translation as T, useAmsSelector
} from "@awe-web/shared/lib";
import PropTypes from "prop-types";
import { Button, FormikLabeledField, FormikSelect, FormikTextInput } from "../../../components/form.js";
import { Col, Row } from "../../../components/grid.js";

const BILLING_ADDRESS_SUBMIT = "ALG0000147";

export default function DeviantBillingAddressForm({getFieldLabel, handleSubmit}) {

    const isFieldRequired = useAmsSelector((state) => newIsFieldRequired("deviantBillingAddress")(state));
    const getFieldPlaceholder = useAmsSelector((state) => newGetFieldPlaceholder("deviantBillingAddress")(state));
    const getSelectFieldOptions = useAmsSelector((state) => newGetSelectFieldOptions("deviantBillingAddress")(state));

  return (
    <form onSubmit={handleSubmit}>
      <Row>
        <Col
          tablet={{ cols: 4 }}
          desktop={{ cols: 4, offset: 2 }}
        >
          <FormikLabeledField
            name="deviantBillingAddress:name"
            as={FormikTextInput}
            className="b2b-payment__form-field"
            getFieldLabel={getFieldLabel}
            isFieldRequired={isFieldRequired}
            placeholder={getFieldPlaceholder("deviantBillingAddress:name")}
          />
        </Col>
      </Row>
      <Row>
        <Col
          tablet={{ cols: 4 }}
          desktop={{ cols: 4, offset: 2 }}
        >
          <FormikLabeledField
            name="deviantBillingAddress:street"
            as={FormikTextInput}
            className="b2b-payment__form-field"
            getFieldLabel={getFieldLabel}
            isFieldRequired={isFieldRequired}
            placeholder={getFieldPlaceholder("deviantBillingAddress:street")}
          />
          <FormikLabeledField
            name="deviantBillingAddress:building"
            as={FormikTextInput}
            className="b2b-payment__form-field"
            getFieldLabel={getFieldLabel}
            isFieldRequired={isFieldRequired}
            placeholder={getFieldPlaceholder("deviantBillingAddress:building")}
          />
        </Col>
        <Col
          tablet={{ cols: 4 }}
          desktop={{ cols: 4 }}
        >
          <div className="b2b-payment__zip-code-and-city">
            <FormikLabeledField
              name="deviantBillingAddress:zipCode"
              as={FormikTextInput}
              className="b2b-payment__form-field b2b-payment__form-field--zip-code"
              getFieldLabel={getFieldLabel}
              isFieldRequired={isFieldRequired}
              placeholder={getFieldPlaceholder("deviantBillingAddress:zipCode")}
            />
            <FormikLabeledField
              name="deviantBillingAddress:city"
              as={FormikTextInput}
              className="b2b-payment__form-field b2b-payment__form-field--city"
              getFieldLabel={getFieldLabel}
              isFieldRequired={isFieldRequired}
              placeholder={getFieldPlaceholder("deviantBillingAddress:city")}
            />
          </div>
          <FormikLabeledField
            name="deviantBillingAddress:countryCode"
            as={FormikSelect}
            className="b2b-payment__form-field b2b-payment__form-field--country-code"
            getFieldLabel={getFieldLabel}
            isFieldRequired={isFieldRequired}
            options={getSelectFieldOptions("deviantBillingAddress:countryCode")}
          />
        </Col>
      </Row>
      <Row>
        <Col
          tablet={{ cols: 4, offset: 4 }}
          desktop={{ cols: 4, offset: 6 }}
        >
          <Button primary continue submit><T code={BILLING_ADDRESS_SUBMIT} /></Button>
        </Col>
      </Row>
    </form>
  );
}

DeviantBillingAddressForm.propTypes = {
  getFieldLabel: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func
};